'use client';

/* empty css                                     */
/* empty css                                        */
/* empty css                                     */
/* empty css                                      */
/* empty css                                      */
/* empty css                                       */
/* empty css                                        */
/* empty css                                         */
/* empty css                                     */
var container = "c5-21-2_wi05kp1 c5-21-2_wi05kp0 c5-21-2_194zije6 c5-21-2_194zijeg c5-21-2_194zijeq c5-21-2_194zije10 c5-21-2_nly6ul0 c5-21-2_nly6ul5 c5-21-2_nly6ul1o c5-21-2_161xunpjg c5-21-2_nly6ul30 c5-21-2_1dohnja8";
var containerBg = { "default": "c5-21-2_wi05kp2 c5-21-2_1dohnja8c", success: "c5-21-2_wi05kp3 c5-21-2_1dohnja96", warning: "c5-21-2_wi05kp4 c5-21-2_1dohnja8w", danger: "c5-21-2_wi05kp5 c5-21-2_1dohnja8m" };
var initial = "c5-21-2_wi05kp7 c5-21-2_wi05kp6 c5-21-2_nly6ul3r";
var visible = "c5-21-2_wi05kp9 c5-21-2_wi05kp8 c5-21-2_nly6ul3r";
var hidden = "c5-21-2_wi05kpb c5-21-2_wi05kpa c5-21-2_nly6ul3q";
var iconWrapper = "c5-21-2_wi05kpc c5-21-2_161xunp7o c5-21-2_161xunp3w c5-21-2_161xunpg c5-21-2_161xunp48 c5-21-2_nly6ul0 c5-21-2_nly6ul2k c5-21-2_nly6ul1k c5-21-2_nly6ul2c c5-21-2_194zije6 c5-21-2_194zijeq";
var iconWrapperBg = { "default": "c5-21-2_wi05kpd c5-21-2_1dohnja8a", success: "c5-21-2_wi05kpe c5-21-2_1dohnja94", warning: "c5-21-2_wi05kpf c5-21-2_1dohnja8u", danger: "c5-21-2_wi05kpg c5-21-2_1dohnja8k" };
var content = "c5-21-2_wi05kpi c5-21-2_wi05kph c5-21-2_161xunpc c5-21-2_161xunp44 c5-21-2_nly6ul0 c5-21-2_nly6ul1k c5-21-2_161xunp28 c5-21-2_nly6ul2o";
var body = "c5-21-2_wi05kpk c5-21-2_wi05kpj c5-21-2_161xunp1w c5-21-2_161xunp5o c5-21-2_nly6ul0 c5-21-2_nly6ul14 c5-21-2_nly6ul1k c5-21-2_161xunp28";
var title = "c5-21-2_wi05kpl c5-21-2_nly6ul3b c5-21-2_nly6ul3d c5-21-2_zqwrxxr";
var dismissButtonWrapper = "c5-21-2_wi05kpm c5-21-2_nly6ul0 c5-21-2_nly6ul2k c5-21-2_nly6ul1k c5-21-2_nly6ul2c";
export {
  body,
  container,
  containerBg,
  content,
  dismissButtonWrapper,
  hidden,
  iconWrapper,
  iconWrapperBg,
  initial,
  title,
  visible
};
